export default __webpack_public_path__ + "static/machine-device-7b889c8adb0831e2725e47f54e9e55f0.svg";